export const GET_EVENT_REQUEST = 'GET_EVENT_REQUEST';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';
export const GET_EVENT_FAILURE = 'GET_EVENT_FAILURE';

export const BUY_EVENT_REQUEST = 'BUY_EVENT_REQUEST';
export const BUY_EVENT_SUCCESSFUL = 'BUY_EVENT_SUCCESSFUL';
export const BUY_EVENT_FAILURE = 'BUY_EVENT_FAILURE';
